var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import React, { createContext, useContext, useEffect, useRef, useState, } from 'react';
import styled from 'styled-components';
import { Box, Alert, Button, Checkbox, DownCaretIcon, MenuItem, Radio, RadioGroup, theme as dsTheme, Typography, WarningOutlinedIcon, TrashOutlinedIcon, IconButton, Dialog, DialogActions, Snackbar, } from '@kareo/design-system';
import { FormControlLabel, Grid, Menu, Divider } from '@material-ui/core';
import rollbar from 'shared-assets/src/errors/errors';
import validateZipcode from '../PaymentSolutions/validateZipcode';
import { FormTextField } from '../PaymentSolutions/NewCardForm/NewCardForm';
import CardTypeDisplay from './CardTypeDisplay';
import CardDetailsContext from '../PaymentSolutions/CollectPayment/CardDetailsContext';
var theme = dsTheme;
var DELETE_SNACKBAR_DURATION = 10000;
var ContainerStyled = styled(Box)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  & + & {\n    margin-top: 1rem;\n  }\n"], ["\n  & + & {\n    margin-top: 1rem;\n  }\n"])));
var FormControlLabelStyled = styled(FormControlLabel)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  width: 100%;\n\n  // sorry for this weird css, for some reason the regular selector isn't working\n  span:nth-child(2) {\n    width: 100%;\n  }\n\n  .MuiFormControlLabel-root {\n    width: 100%;\n  }\n"], ["\n  display: flex;\n  width: 100%;\n\n  // sorry for this weird css, for some reason the regular selector isn't working\n  span:nth-child(2) {\n    width: 100%;\n  }\n\n  .MuiFormControlLabel-root {\n    width: 100%;\n  }\n"])));
var RadioStyled = styled(Radio)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  align-self: flex-start;\n"], ["\n  align-self: flex-start;\n"])));
function formatBillingAddress(billingAddress, billingCity, billingState, billingZip) {
    var formattedAddress = '';
    if (!!billingAddress) {
        formattedAddress += billingAddress + ' ';
    }
    if (!!billingCity) {
        formattedAddress += billingCity + ', ';
    }
    if (!!billingState) {
        formattedAddress += billingState + ' ';
    }
    if (!!billingZip) {
        formattedAddress += billingZip + ' ';
    }
    return formattedAddress;
}
function isCardExpiringSoon(expirationMonth, expirationYear) {
    var currentDate = new Date();
    // Returns 0-11
    var currentMonth = currentDate.getMonth() + 1;
    var currentYear = currentDate.getFullYear();
    var year = expirationYear <= 99 ? 2000 + expirationYear : expirationYear;
    // Cards expiring in January should start showing expiring soon in December of the previous year.
    var shouldShowDecemberExpiringSoon = year - 1 === currentYear && expirationMonth === 1 && currentMonth === 12;
    var shouldShowExpiringSoon = currentYear === year &&
        (currentMonth === expirationMonth - 1 || currentMonth === expirationMonth);
    // Start raising expiring soon one month before expiration month.
    return shouldShowExpiringSoon || shouldShowDecemberExpiringSoon;
}
function isCardExpired(expirationMonth, expirationYear) {
    var currentDate = new Date();
    // Returns 0-11
    var currentMonth = currentDate.getMonth() + 1;
    var currentYear = currentDate.getFullYear();
    var year = expirationYear <= 99 ? 2000 + expirationYear : expirationYear;
    var expiredDueToYear = currentYear > year;
    var expiredDueToMonth = currentYear === year && currentMonth > expirationMonth;
    return expiredDueToYear || expiredDueToMonth;
}
var CardListConfigContext = createContext({
    showRadioSelector: false,
    shouldRenderCardDescription: false,
    shouldRenderActions: false,
    shouldShowDeleteCardButton: true,
});
// ---
function CardInfoDisplay(props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    var cardNickname = props.cardNickname, cardType = props.cardType, last4 = props.last4, expMonth = props.expMonth, expYear = props.expYear, defaultCard = props.defaultCard, showCardDetails = props.showCardDetails, setShowCardDetails = props.setShowCardDetails, hoveringOverDelete = props.hoveringOverDelete, setHoveringOverDelete = props.setHoveringOverDelete, setShowDeleteConfirmationModal = props.setShowDeleteConfirmationModal, cardId = props.cardId, setCardIdToBeDeleted = props.setCardIdToBeDeleted, onEditCard = props.onEditCard, onSetDefaultCard = props.onSetDefaultCard, disabled = props.disabled;
    var _m = useContext(CardListConfigContext), shouldRenderActions = _m.shouldRenderActions, shouldShowDeleteCardButton = _m.shouldShowDeleteCardButton;
    var _o = useState(null), anchorEl = _o[0], setAnchorEl = _o[1];
    var open = Boolean(anchorEl);
    var showExpiringSoon = isCardExpiringSoon(expMonth, expYear);
    var showExpired = isCardExpired(expMonth, expYear);
    var handleClick = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handleSetAnchorEl = function () {
        setAnchorEl(null);
    };
    var handleShowCardDetails = function () {
        handleSetAnchorEl();
        setShowCardDetails(true);
    };
    var handleHideCardDetails = function () {
        handleSetAnchorEl();
        setShowCardDetails(false);
    };
    var handleOpenDeleteConfirmationModal = function () {
        handleSetAnchorEl();
        setShowDeleteConfirmationModal(true);
        setCardIdToBeDeleted(cardId === null || cardId === void 0 ? void 0 : cardId.toString());
    };
    return (React.createElement(Grid, { container: true, alignItems: "center", spacing: 1 },
        React.createElement(Grid, { item: true },
            React.createElement(Box, { display: "flex", width: "32px", height: "32px" },
                React.createElement(CardTypeDisplay, { type: cardType }))),
        React.createElement(Grid, { item: true },
            React.createElement(Box, { fontWeight: "fontWeightBold" }, cardNickname || (cardType === null || cardType === void 0 ? void 0 : cardType.toLocaleUpperCase()))),
        React.createElement(Grid, { item: true }, "- " + last4),
        React.createElement(Grid, { item: true }, "(Exp " + expMonth + "/" + expYear + ")"),
        showExpiringSoon && !showExpired && (React.createElement(Grid, { item: true, style: {
                color: (_b = (_a = theme.palette) === null || _a === void 0 ? void 0 : _a.vitality) === null || _b === void 0 ? void 0 : _b.main,
                display: 'contents',
                fontSize: '14px',
            } },
            React.createElement("div", { style: { display: 'contents' } },
                React.createElement(WarningOutlinedIcon, { fontSize: "xsmall" })),
            React.createElement("b", { style: { marginLeft: '5px', marginTop: '1px' } }, "Expiring Soon"))),
        showExpired && !showExpiringSoon && (React.createElement(Grid, { item: true, style: {
                color: (_d = (_c = theme.palette) === null || _c === void 0 ? void 0 : _c.error) === null || _d === void 0 ? void 0 : _d.dark,
                display: 'contents',
                fontSize: '14px',
            } },
            React.createElement("div", { style: { display: 'contents' } },
                React.createElement(WarningOutlinedIcon, { fontSize: "xsmall" })),
            React.createElement("b", { style: { marginLeft: '5px', marginTop: '1px' } }, "Expired"))),
        shouldShowDeleteCardButton && (React.createElement(Box, { marginLeft: "auto", display: "flex", alignItems: "baseline", color: (_f = (_e = theme.palette) === null || _e === void 0 ? void 0 : _e.primary) === null || _f === void 0 ? void 0 : _f.main },
            React.createElement(IconButton, { "aria-label": "Remove card ending in " + last4, onClick: handleOpenDeleteConfirmationModal, onMouseEnter: function () { return setHoveringOverDelete(true); }, onMouseLeave: function () { return setHoveringOverDelete(false); } },
                React.createElement(TrashOutlinedIcon, { onMouseEnter: function () { return setHoveringOverDelete(true); }, onMouseLeave: function () { return setHoveringOverDelete(false); }, fontSize: "small", color: hoveringOverDelete ? 'error' : undefined })))),
        shouldRenderActions && (React.createElement(Box, { marginLeft: "auto", display: "flex", alignItems: "center", color: (_h = (_g = theme.palette) === null || _g === void 0 ? void 0 : _g.primary) === null || _h === void 0 ? void 0 : _h.main },
            defaultCard && (React.createElement(Box, { display: "flex", alignItems: "center", height: "32px", padding: "0 12px", borderRadius: "16px", bgcolor: (_j = theme.palette) === null || _j === void 0 ? void 0 : _j.core[200], color: (_k = theme.palette) === null || _k === void 0 ? void 0 : _k.common.black, fontSize: "14px", fontWeight: "fontWeightMedium" }, "Default")),
            React.createElement(Box, { marginLeft: "20px" },
                React.createElement(Button, { id: "basic-button", "aria-controls": open ? 'basic-menu' : undefined, "aria-expanded": open ? 'true' : undefined, variant: "text", onClick: handleClick, disabled: disabled, disableRipple: true, endIcon: React.createElement(DownCaretIcon, { fontSize: "xsmall" }) }, "Actions")),
            React.createElement(Menu, { id: "basic-menu", anchorEl: anchorEl, open: open, onClose: handleSetAnchorEl, getContentAnchorEl: null, anchorOrigin: { vertical: 'bottom', horizontal: 'left' }, transformOrigin: { vertical: 'top', horizontal: 'left' }, MenuListProps: {
                    style: {
                        padding: 0,
                        margin: 0,
                    },
                } },
                onEditCard && (React.createElement(MenuItem, { onClick: function () {
                        handleSetAnchorEl();
                        onEditCard(props);
                    } }, "Edit Card")),
                onSetDefaultCard && !defaultCard && !showExpired && (React.createElement(MenuItem, { onClick: function () {
                        handleSetAnchorEl();
                        onSetDefaultCard(props);
                    } }, "Set as default")),
                !showCardDetails && (React.createElement(MenuItem, { onClick: handleShowCardDetails }, "Show Details")),
                showCardDetails && (React.createElement(MenuItem, { onClick: handleHideCardDetails }, "Hide Details")),
                React.createElement(MenuItem, { onClick: handleOpenDeleteConfirmationModal },
                    React.createElement(Box, { color: (_l = theme === null || theme === void 0 ? void 0 : theme.palette) === null || _l === void 0 ? void 0 : _l.secondary.dark }, "Remove Card")))))));
}
function DefinitionItem(props) {
    return React.createElement(Grid, __assign({ container: true, xs: 12, direction: "row" }, props));
}
function DefinitionTerm(props) {
    return (React.createElement(Grid, { item: true, xs: 2 },
        React.createElement(Typography, __assign({ component: "span", variant: "body2" }, props))));
}
function DefinitionDescription(props) {
    return (React.createElement(Grid, { item: true, xs: 10 },
        React.createElement(Typography, __assign({ component: "span", variant: "body2" }, props))));
}
function CardDetailsDisplay(props) {
    var billingAddress = props.billingAddress, billingCity = props.billingCity, billingState = props.billingState, billingZip = props.billingZip, cardDescription = props.cardDescription, expMonth = props.expMonth, expYear = props.expYear, last4 = props.last4;
    var isCardDescriptionPresent = !!cardDescription && cardDescription.length > 0;
    var formattedBillingAddress = formatBillingAddress(billingAddress, billingCity, billingState, billingZip);
    var isBillingAddressPresent = formattedBillingAddress.length > 0;
    return (React.createElement(Grid, { container: true, style: { marginLeft: 40 }, component: "dl" },
        isBillingAddressPresent && (React.createElement(DefinitionItem, null,
            React.createElement(DefinitionTerm, null, "Billing Address"),
            React.createElement(DefinitionDescription, null, formattedBillingAddress))),
        isCardDescriptionPresent && (React.createElement(DefinitionItem, null,
            React.createElement(DefinitionTerm, null, "Comments"),
            React.createElement(DefinitionDescription, null, cardDescription))),
        React.createElement(DefinitionItem, null,
            React.createElement(DefinitionTerm, null, "Number"),
            React.createElement(DefinitionDescription, null,
                "Ending in ",
                last4)),
        React.createElement(DefinitionItem, null,
            React.createElement(DefinitionTerm, null, "Expiration Date"),
            React.createElement(DefinitionDescription, null,
                expMonth,
                "/",
                expYear))));
}
function SavedCardInner(props) {
    var cardDescription = props.cardDescription;
    var shouldRenderCardDescription = useContext(CardListConfigContext).shouldRenderCardDescription;
    var _a = useState(false), showCardDetails = _a[0], setShowCardDetails = _a[1];
    var isCardDescriptionPresent = !!cardDescription && cardDescription.length > 0;
    return (React.createElement(Box, { width: "100%", display: "flex", flexDirection: "column" },
        React.createElement(CardInfoDisplay, __assign({ showCardDetails: showCardDetails, setShowCardDetails: setShowCardDetails }, props)),
        isCardDescriptionPresent &&
            !showCardDetails &&
            shouldRenderCardDescription && (React.createElement(Typography, { variant: "body2", component: "span", style: { marginLeft: '40px' } }, cardDescription)),
        showCardDetails && (React.createElement(CardDetailsDisplay, __assign({}, props, { showCardDetails: showCardDetails })))));
}
export function SavedCardListItem(props) {
    var _a, _b, _c;
    var _d = useState(false), hoveringOverDelete = _d[0], setHoveringOverDelete = _d[1];
    var showRadioSelector = useContext(CardListConfigContext).showRadioSelector;
    return (React.createElement(ContainerStyled, { paddingTop: 1, paddingBottom: 1, paddingLeft: 2, paddingRight: 2, border: 1, borderColor: hoveringOverDelete
            ? (_a = theme.palette) === null || _a === void 0 ? void 0 : _a.error.main : (_b = theme.palette) === null || _b === void 0 ? void 0 : _b.grey[500], borderRadius: "5px", style: {
            backgroundColor: hoveringOverDelete
                ? (_c = theme.palette) === null || _c === void 0 ? void 0 : _c.vitality[100] : undefined,
        } },
        showRadioSelector && (React.createElement(FormControlLabelStyled, { disabled: props.disabled, value: props.cardId, control: React.createElement(RadioStyled, null), label: React.createElement(SavedCardInner, __assign({ setHoveringOverDelete: setHoveringOverDelete, hoveringOverDelete: hoveringOverDelete }, props)) })),
        !showRadioSelector && (React.createElement(SavedCardInner, __assign({ setHoveringOverDelete: setHoveringOverDelete, hoveringOverDelete: hoveringOverDelete }, props)))));
}
export function SavedCardList(props) {
    var _this = this;
    var _a, _b, _c, _d, _e;
    var _f = props.cards, cards = _f === void 0 ? [] : _f, disabled = props.disabled, config = props.config, onDeleteCard = props.onDeleteCard, onUpdateCard = props.onUpdateCard, patientAddress = props.patientAddress;
    var _g = useContext(CardDetailsContext), selectedCard = _g.selectedCard, setSelectedCard = _g.setSelectedCard, patient = _g.patient, deleteCard = _g.deleteCard;
    var _h = useState(null), editingCard = _h[0], setEditingCard = _h[1];
    var hasPatientAddress = Boolean(patientAddress &&
        [
            patientAddress.address1,
            patientAddress.addressCity,
            patientAddress.addressState,
            patientAddress.addressZipcode,
        ].some(Boolean));
    var _j = useState(false), usePatientAddress = _j[0], setUsePatientAddress = _j[1];
    var _k = useState(''), editError = _k[0], setEditError = _k[1];
    var _l = useState(false), savingEdit = _l[0], setSavingEdit = _l[1];
    var _m = useState(''), updateError = _m[0], setUpdateError = _m[1];
    var _o = useState(false), cardListStale = _o[0], setCardListStale = _o[1];
    var updatingCardRef = useRef(false);
    var _p = useState(false), updatingCard = _p[0], setUpdatingCard = _p[1];
    var editCard = function (card) {
        setEditError('');
        setUpdateError('');
        setEditingCard(__assign({}, card));
        setUsePatientAddress(hasPatientAddress &&
            (card.billingAddress || '') === ((patientAddress === null || patientAddress === void 0 ? void 0 : patientAddress.address1) || '') &&
            (card.billingCity || '') === ((patientAddress === null || patientAddress === void 0 ? void 0 : patientAddress.addressCity) || '') &&
            (card.billingState || '') === ((patientAddress === null || patientAddress === void 0 ? void 0 : patientAddress.addressState) || '') &&
            (card.billingZip || '') === ((patientAddress === null || patientAddress === void 0 ? void 0 : patientAddress.addressZipcode) || ''));
    };
    var saveEdit = function (event) { return __awaiter(_this, void 0, void 0, function () {
        var expirationYear, currentDate, updated, error_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    event.preventDefault();
                    if (!editingCard || !onUpdateCard || updatingCardRef.current)
                        return [2 /*return*/];
                    expirationYear = editingCard.expYear <= 99
                        ? 2000 + editingCard.expYear
                        : editingCard.expYear;
                    currentDate = new Date();
                    if (editingCard.expMonth < 1 ||
                        editingCard.expMonth > 12 ||
                        expirationYear > 2099 ||
                        expirationYear < currentDate.getFullYear() ||
                        (expirationYear === currentDate.getFullYear() &&
                            editingCard.expMonth < currentDate.getMonth() + 1)) {
                        setEditError('Enter a current or future expiration date.');
                        return [2 /*return*/];
                    }
                    if (editingCard.billingZip && !validateZipcode(editingCard.billingZip)) {
                        setEditError('Enter a valid billing ZIP code.');
                        return [2 /*return*/];
                    }
                    setSavingEdit(true);
                    updatingCardRef.current = true;
                    setUpdatingCard(true);
                    setEditError('');
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, onUpdateCard(editingCard)];
                case 2:
                    updated = _b.sent();
                    if (!updated || updated.cardId !== editingCard.cardId) {
                        throw new Error('Invalid card update response');
                    }
                    if ((selectedCard === null || selectedCard === void 0 ? void 0 : selectedCard.cardId) === updated.cardId) {
                        setSelectedCard(updated);
                    }
                    setCardListStale(false);
                    setEditingCard(null);
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _b.sent();
                    if ((_a = error_1) === null || _a === void 0 ? void 0 : _a.cardUpdated) {
                        setEditingCard(null);
                        setUpdateError(error_1.message);
                        setCardListStale(true);
                    }
                    else {
                        setEditError('Unable to update card. Please try again.');
                    }
                    return [3 /*break*/, 5];
                case 4:
                    setSavingEdit(false);
                    updatingCardRef.current = false;
                    setUpdatingCard(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var setDefaultCard = function (card) { return __awaiter(_this, void 0, void 0, function () {
        var updated, error_2;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!onUpdateCard ||
                        updatingCardRef.current ||
                        card.defaultCard ||
                        isCardExpired(card.expMonth, card.expYear))
                        return [2 /*return*/];
                    updatingCardRef.current = true;
                    setUpdatingCard(true);
                    setUpdateError('');
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, onUpdateCard(__assign(__assign({}, card), { defaultCard: true }))];
                case 2:
                    updated = _c.sent();
                    if (!updated || updated.cardId !== card.cardId) {
                        throw new Error('Invalid card update response');
                    }
                    if ((selectedCard === null || selectedCard === void 0 ? void 0 : selectedCard.cardId) === updated.cardId) {
                        setSelectedCard(updated);
                    }
                    setCardListStale(false);
                    return [3 /*break*/, 5];
                case 3:
                    error_2 = _c.sent();
                    setUpdateError(((_a = error_2) === null || _a === void 0 ? void 0 : _a.cardUpdated) ? error_2.message
                        : 'Unable to set the default card. Please try again.');
                    if ((_b = error_2) === null || _b === void 0 ? void 0 : _b.cardUpdated)
                        setCardListStale(true);
                    return [3 /*break*/, 5];
                case 4:
                    updatingCardRef.current = false;
                    setUpdatingCard(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var _q = useState([]), hiddenCardIds = _q[0], setHiddenCardIds = _q[1];
    var _r = useState(false), snackbarOpen = _r[0], setSnackbarOpen = _r[1];
    var _s = useState(''), snackbarMessage = _s[0], setSnackbarMessage = _s[1];
    var _t = useState('success'), snackbarType = _t[0], setSnackbarType = _t[1];
    var pendingDeletionRef = useRef(null);
    var deleteTimerRef = useRef();
    var deleteCardHandlerRef = useRef(onDeleteCard);
    var contextDeleteCardRef = useRef(deleteCard);
    var patientRef = useRef(patient);
    var mountedRef = useRef(true);
    var selectedCardRef = useRef(selectedCard);
    var selectedCardsPendingDeletionRef = useRef({});
    var queuedDeleteErrorRef = useRef(false);
    deleteCardHandlerRef.current = onDeleteCard;
    contextDeleteCardRef.current = deleteCard;
    patientRef.current = patient;
    selectedCardRef.current = selectedCard;
    useEffect(function () {
        return function () {
            mountedRef.current = false;
            if (deleteTimerRef.current) {
                clearTimeout(deleteTimerRef.current);
            }
            var pendingCard = pendingDeletionRef.current;
            if (pendingCard) {
                pendingDeletionRef.current = null;
                void deleteCardForCard(pendingCard).catch(function (error) {
                    rollbar.error(error);
                });
            }
        };
    }, []);
    useEffect(function () {
        setHiddenCardIds(function (currentHiddenCardIds) {
            return currentHiddenCardIds.filter(function (cardId) {
                return cards.some(function (card) { return card.cardId.toString() === cardId; });
            });
        });
    }, [cards]);
    var _u = useState(false), showDeleteConfirmationModal = _u[0], setShowDeleteConfirmationModal = _u[1];
    var _v = useState(''), cardIdToBeDeleted = _v[0], setCardIdToBeDeleted = _v[1];
    var deleteCardForCard = function (card) {
        var customDeleteCard = deleteCardHandlerRef.current;
        if (customDeleteCard) {
            return customDeleteCard(card);
        }
        if (patientRef.current.patientId !== -1) {
            return contextDeleteCardRef.current(card.cardId.toString());
        }
        return Promise.reject(new Error('Unable to delete card without a patient'));
    };
    var clearSelectedCardPendingDeletion = function (card) {
        delete selectedCardsPendingDeletionRef.current[card.cardId.toString()];
    };
    var restoreSelectedCardPendingDeletion = function (card) {
        var cardId = card.cardId.toString();
        var selectedCardBeforeDeletion = selectedCardsPendingDeletionRef.current[cardId];
        clearSelectedCardPendingDeletion(card);
        if (selectedCardBeforeDeletion && selectedCardRef.current === null) {
            selectedCardRef.current = selectedCardBeforeDeletion;
            setSelectedCard(selectedCardBeforeDeletion);
        }
    };
    var showDeleteError = function () {
        queuedDeleteErrorRef.current = false;
        setSnackbarMessage('Unable to remove card. Please try again.');
        setSnackbarType('info');
        setSnackbarOpen(true);
    };
    var showQueuedDeleteError = function () {
        if (queuedDeleteErrorRef.current) {
            showDeleteError();
            return true;
        }
        return false;
    };
    var commitCardDeletion = function (card) {
        void deleteCardForCard(card)
            .then(function () { return clearSelectedCardPendingDeletion(card); })
            .catch(function (error) {
            if (!mountedRef.current) {
                rollbar.error(error);
                return;
            }
            setHiddenCardIds(function (currentHiddenCardIds) {
                return currentHiddenCardIds.filter(function (cardId) { return cardId !== card.cardId.toString(); });
            });
            restoreSelectedCardPendingDeletion(card);
            if (pendingDeletionRef.current) {
                queuedDeleteErrorRef.current = true;
            }
            else {
                showDeleteError();
            }
        });
    };
    var commitPendingDeletion = function (card) {
        if (pendingDeletionRef.current === null ||
            pendingDeletionRef.current.cardId !== card.cardId) {
            return;
        }
        pendingDeletionRef.current = null;
        if (deleteTimerRef.current) {
            clearTimeout(deleteTimerRef.current);
            deleteTimerRef.current = undefined;
        }
        setSnackbarOpen(false);
        commitCardDeletion(card);
        showQueuedDeleteError();
    };
    var handleUndoDelete = function () {
        var pendingCard = pendingDeletionRef.current;
        if (!pendingCard) {
            return;
        }
        if (deleteTimerRef.current) {
            clearTimeout(deleteTimerRef.current);
            deleteTimerRef.current = undefined;
        }
        pendingDeletionRef.current = null;
        setHiddenCardIds(function (currentHiddenCardIds) {
            return currentHiddenCardIds.filter(function (cardId) { return cardId !== pendingCard.cardId.toString(); });
        });
        restoreSelectedCardPendingDeletion(pendingCard);
        if (!showQueuedDeleteError()) {
            setSnackbarOpen(false);
        }
    };
    var handleDeleteCardOnFile = function () {
        var cardToDelete = cards.find(function (card) { return card.cardId.toString() === cardIdToBeDeleted; });
        if (!cardToDelete) {
            return;
        }
        var pendingCard = pendingDeletionRef.current;
        if (pendingCard) {
            if (deleteTimerRef.current) {
                clearTimeout(deleteTimerRef.current);
                deleteTimerRef.current = undefined;
            }
            pendingDeletionRef.current = null;
        }
        setHiddenCardIds(function (currentHiddenCardIds) {
            return currentHiddenCardIds.includes(cardToDelete.cardId.toString())
                ? currentHiddenCardIds
                : __spreadArrays(currentHiddenCardIds, [cardToDelete.cardId.toString()]);
        });
        if ((selectedCard === null || selectedCard === void 0 ? void 0 : selectedCard.cardId) === cardToDelete.cardId) {
            selectedCardsPendingDeletionRef.current[cardToDelete.cardId.toString()] = cardToDelete;
            selectedCardRef.current = null;
            setSelectedCard(null);
        }
        pendingDeletionRef.current = cardToDelete;
        setSnackbarMessage('Card removed.');
        setSnackbarType('success');
        setSnackbarOpen(true);
        setShowDeleteConfirmationModal(false);
        deleteTimerRef.current = setTimeout(function () {
            commitPendingDeletion(cardToDelete);
        }, DELETE_SNACKBAR_DURATION);
        // The latest card must own the active Undo state before the earlier
        // deletion updates the Angular card list in the background.
        if (pendingCard) {
            commitCardDeletion(pendingCard);
        }
    };
    var handleSnackbarClose = function (event, reason) {
        if (reason === 'clickaway' && pendingDeletionRef.current) {
            return;
        }
        setSnackbarOpen(false);
    };
    function onChangeSelectedCard(evt, value) {
        var cardData = cards.find(function (card) { return card.cardId.toString() === value; });
        if (cardData !== undefined) {
            setSelectedCard(cardData);
        }
    }
    var inferredConfig = {
        shouldRenderActions: (_a = config === null || config === void 0 ? void 0 : config.shouldRenderActions) !== null && _a !== void 0 ? _a : false,
        shouldRenderCardDescription: (_b = config === null || config === void 0 ? void 0 : config.shouldRenderCardDescription) !== null && _b !== void 0 ? _b : false,
        showRadioSelector: (_c = config === null || config === void 0 ? void 0 : config.showRadioSelector) !== null && _c !== void 0 ? _c : false,
        shouldShowDeleteCardButton: (_d = config === null || config === void 0 ? void 0 : config.shouldShowDeleteCardButton) !== null && _d !== void 0 ? _d : true,
    };
    var visibleCards = cards.filter(function (card) { return !hiddenCardIds.includes(card.cardId.toString()); });
    return (React.createElement("div", null,
        updateError && React.createElement(Alert, { severity: "error" }, updateError),
        React.createElement(Dialog, { open: !!editingCard, onClose: function () { return !savingEdit && setEditingCard(null); }, maxWidth: "sm", fullWidth: true }, editingCard && (React.createElement("form", { onSubmit: saveEdit },
            React.createElement(Box, { p: 2 },
                React.createElement(Box, { alignItems: "center", display: "flex", justifyContent: "space-between" },
                    React.createElement(Typography, { variant: "h2" }, "Edit Card"),
                    React.createElement(FormControlLabel, { control: React.createElement(Checkbox, { checked: Boolean(editingCard.defaultCard), disabled: Boolean((_e = cards.find(function (card) { return card.cardId === editingCard.cardId; })) === null || _e === void 0 ? void 0 : _e.defaultCard), onChange: function (event) {
                                return setEditingCard(__assign(__assign({}, editingCard), { defaultCard: event.target.checked }));
                            } }), label: "Make this my default card", style: { marginRight: 0 } })),
                React.createElement(Grid, { container: true, spacing: 1, style: { marginTop: 8 } },
                    React.createElement(Grid, { item: true, xs: 12 },
                        React.createElement(FormTextField, { id: "edit-card-number", name: "cardNumber", label: "Card Number", value: "**** **** **** " + editingCard.last4, disabled: true })),
                    React.createElement(Grid, { item: true, xs: 6 },
                        React.createElement(FormTextField, { id: "edit-expiration-month", name: "expMonth", label: "Expiration Month", type: "number", inputProps: { min: 1, max: 12 }, value: editingCard.expMonth, onChange: function (event) {
                                return setEditingCard(__assign(__assign({}, editingCard), { expMonth: Number(event.target.value) }));
                            }, required: true })),
                    React.createElement(Grid, { item: true, xs: 6 },
                        React.createElement(FormTextField, { id: "edit-expiration-year", name: "expYear", label: "Expiration Year", type: "number", inputProps: {
                                min: 0,
                                max: 9999,
                            }, value: editingCard.expYear, onChange: function (event) {
                                return setEditingCard(__assign(__assign({}, editingCard), { expYear: Number(event.target.value) }));
                            }, required: true })),
                    React.createElement(Grid, { item: true, xs: 12 },
                        React.createElement(FormTextField, { id: "edit-card-nickname", name: "cardNickname", label: "Card Nickname", placeholder: "Enter card nickname", inputProps: { maxLength: 255 }, value: editingCard.cardNickname || '', onChange: function (event) {
                                return setEditingCard(__assign(__assign({}, editingCard), { cardNickname: event.target.value }));
                            } })),
                    React.createElement(Grid, { item: true, xs: 12 },
                        React.createElement(FormTextField, { id: "edit-card-description", name: "cardDescription", label: "Comments for the practice", placeholder: "Enter comments for the practice", inputProps: { maxLength: 60 }, value: editingCard.cardDescription || '', onChange: function (event) {
                                return setEditingCard(__assign(__assign({}, editingCard), { cardDescription: event.target.value }));
                            } }),
                        React.createElement(Box, { textAlign: "right" },
                            React.createElement(Typography, { variant: "body2" },
                                (editingCard.cardDescription || '').length,
                                "/60"))),
                    hasPatientAddress && (React.createElement(Grid, { item: true, xs: 12 },
                        React.createElement(FormControlLabel, { control: React.createElement(Checkbox, { checked: usePatientAddress, onChange: function (event) {
                                    var checked = event.target.checked;
                                    setUsePatientAddress(checked);
                                    if (checked) {
                                        setEditingCard(__assign(__assign({}, editingCard), { billingAddress: (patientAddress === null || patientAddress === void 0 ? void 0 : patientAddress.address1) || '', billingCity: (patientAddress === null || patientAddress === void 0 ? void 0 : patientAddress.addressCity) || '', billingState: (patientAddress === null || patientAddress === void 0 ? void 0 : patientAddress.addressState) || '', billingZip: (patientAddress === null || patientAddress === void 0 ? void 0 : patientAddress.addressZipcode) || '' }));
                                    }
                                } }), label: "Use patient's address as billing address" }))),
                    React.createElement(Grid, { item: true, xs: 6 },
                        React.createElement(FormTextField, { id: "edit-billing-address", name: "billingAddress", label: "Billing Address", placeholder: "Enter billing address", inputProps: { maxLength: 50 }, value: editingCard.billingAddress || '', disabled: usePatientAddress, onChange: function (event) {
                                return setEditingCard(__assign(__assign({}, editingCard), { billingAddress: event.target.value }));
                            } })),
                    React.createElement(Grid, { item: true, xs: 6 },
                        React.createElement(FormTextField, { id: "edit-billing-city", name: "billingCity", label: "City", placeholder: "Enter city", inputProps: { maxLength: 50 }, value: editingCard.billingCity || '', disabled: usePatientAddress, onChange: function (event) {
                                return setEditingCard(__assign(__assign({}, editingCard), { billingCity: event.target.value }));
                            } })),
                    React.createElement(Grid, { item: true, xs: 6 },
                        React.createElement(FormTextField, { id: "edit-billing-state", name: "billingState", label: "State", placeholder: "Enter state", inputProps: { maxLength: 50 }, value: editingCard.billingState || '', disabled: usePatientAddress, onChange: function (event) {
                                return setEditingCard(__assign(__assign({}, editingCard), { billingState: event.target.value }));
                            } })),
                    React.createElement(Grid, { item: true, xs: 6 },
                        React.createElement(FormTextField, { id: "edit-billing-zip", name: "billingZip", label: "Zip Code", placeholder: "Enter ZIP code", inputProps: { maxLength: 12 }, value: editingCard.billingZip || '', disabled: usePatientAddress, onChange: function (event) {
                                return setEditingCard(__assign(__assign({}, editingCard), { billingZip: event.target.value }));
                            } }))),
                editError && React.createElement(Typography, { color: "error" }, editError)),
            React.createElement(DialogActions, null,
                (onDeleteCard || patient.patientId !== -1) && (React.createElement(Button, { type: "button", variant: "text", onClick: function () {
                        setCardIdToBeDeleted(String(editingCard.cardId));
                        setEditingCard(null);
                        setShowDeleteConfirmationModal(true);
                    }, disabled: savingEdit, style: { marginRight: 'auto' } }, "Remove Card")),
                React.createElement(Button, { type: "button", variant: "text", onClick: function () { return setEditingCard(null); }, disabled: savingEdit }, "Cancel"),
                React.createElement(Button, { type: "submit", color: "vitality", disabled: savingEdit }, "Save Card"))))),
        showDeleteConfirmationModal && (React.createElement(Dialog, __assign({}, props, { open: showDeleteConfirmationModal, onClose: function () { return setShowDeleteConfirmationModal(false); }, "aria-labelledby": "cta-dialog-title" }),
            React.createElement("div", { style: { margin: '8px 16px' } },
                React.createElement(Typography, { variant: "h2" }, "Remove Card?"),
                React.createElement(Typography, { variant: "body1" }, "Are you sure you want to remove this card? You will need to add the card again if you want to use it for future transactions.")),
            React.createElement(Divider, { style: { height: '1px' } }),
            React.createElement(DialogActions, null,
                React.createElement(Box, null,
                    React.createElement(Button, { onClick: function () { return setShowDeleteConfirmationModal(false); }, variant: "text", color: "vitality" }, "Cancel"),
                    React.createElement(Button, { onClick: handleDeleteCardOnFile, color: "vitality" }, "Remove"))))),
        !cardListStale && (React.createElement(CardListConfigContext.Provider, { value: inferredConfig },
            React.createElement(RadioGroup, { value: (selectedCard === null || selectedCard === void 0 ? void 0 : selectedCard.cardId) || null, onChange: onChangeSelectedCard }, visibleCards.map(function (data) { return (React.createElement(SavedCardListItem, __assign({ key: "card-" + data.cardId + "-key", setShowDeleteConfirmationModal: setShowDeleteConfirmationModal, setCardIdToBeDeleted: setCardIdToBeDeleted, disabled: disabled || updatingCard, onEditCard: onUpdateCard && !updatingCard ? editCard : undefined, onSetDefaultCard: onUpdateCard && !updatingCard ? setDefaultCard : undefined }, data))); })))),
        React.createElement(Snackbar, { open: snackbarOpen, onClose: handleSnackbarClose, type: snackbarType, message: snackbarMessage, 
            // The deletion timer is the source of truth for the Undo window. Letting
            // Material UI run a second timer can close Undo before that window ends.
            autoHideDuration: pendingDeletionRef.current ? null : DELETE_SNACKBAR_DURATION, action: pendingDeletionRef.current ? (React.createElement(Button, { variant: "text", onClick: handleUndoDelete }, "UNDO")) : undefined })));
}
export default SavedCardList;
var templateObject_1, templateObject_2, templateObject_3;
